import '../../styles/Card.css';

export default function Card({ Nome, Imagem, Descricao }) {
  return (
    <div className="card">
      {Imagem && <img src={Imagem} alt={Nome} className="image" />}
      <div className="body">
        {Nome && <h2 className="title">{Nome}</h2>}
        {Descricao && <p className="text">{Descricao}</p>}
      </div>
    </div>
  );
}
